let menuItems = document.querySelectorAll('.menu .nav-main-item');

menuItems.forEach(function(item) {
    item.addEventListener('click',function(){
        let activeItem = document.querySelector('.nav-main-item.active');
        this.classList.toggle('active');
        if(activeItem){
            activeItem.classList.remove('active');
        }
    })
});
